// extracted by mini-css-extract-plugin
export var active = "_99-1";
export var activeSubdued = "_99-2";
export var compact = "_99-3";
export var fill = "_99-6";
export var pulse = "_99-4";
export var settingHighlightPulse = "_99-5";
export var wrapper = "_99-0";